import {ModelDate} from '../../shared/DTO/modelDate';
import {SubjectRole} from '../../shared/DTO/subjectRole';
import {ContactModel} from './contact.model';
import {ResidenceModel} from './residence.model';
import {BaseModel} from '../../base/models/base-model.model';

export class SubjectModel extends BaseModel {
  private _birthCity?: string;
  private _birthCountry?: string;
  private _birthDate?: ModelDate;
  private _birthState?: string;
  private _citizenship?: string;
  private _contacts?: Array<ContactModel>;
  private _denomination?: string;
  private _domicile?: ResidenceModel;
  private _gender?: string;
  private _name?: string;
  private _office?: ResidenceModel;
  private _residence?: ResidenceModel;
  private _role?: SubjectRole;
  private _surname?: string;
  private _taxCode?: string;
  private _vat?: string;

  constructor(birthCity?: string, birthCountry?: string, birthDate?: ModelDate, birthState?: string, citizenship?: string, contacts?: Array<ContactModel>, denomination?: string, domicile?: ResidenceModel, gender?: string, id?: string, name?: string, office?: ResidenceModel, residence?: ResidenceModel, role?: SubjectRole, surname?: string, taxCode?: string, vat?: string) {
    super();
    this._birthCity = birthCity;
    this._birthCountry = birthCountry;
    this._birthDate = birthDate;
    this._birthState = birthState;
    this._citizenship = citizenship;
    this._contacts = contacts;
    this._denomination = denomination;
    this._domicile = domicile;
    this._gender = gender;
    this._id = id;
    this._name = name;
    this._office = office;
    this._residence = residence;
    this._role = role;
    this._surname = surname;
    this._taxCode = taxCode;
    this._vat = vat;
  }

  get birthCity(): string {
    return this._birthCity;
  }

  set birthCity(value: string) {
    this._birthCity = value;
  }

  get birthCountry(): string {
    return this._birthCountry;
  }

  set birthCountry(value: string) {
    this._birthCountry = value;
  }

  get birthDate(): ModelDate {
    return this._birthDate;
  }

  set birthDate(value: ModelDate) {
    this._birthDate = value;
  }

  get birthState(): string {
    return this._birthState;
  }

  set birthState(value: string) {
    this._birthState = value;
  }

  get citizenship(): string {
    return this._citizenship;
  }

  set citizenship(value: string) {
    this._citizenship = value;
  }

  get contacts(): Array<ContactModel> {
    return this._contacts;
  }

  set contacts(value: Array<ContactModel>) {
    this._contacts = value;
  }

  get denomination(): string {
    return this._denomination;
  }

  set denomination(value: string) {
    this._denomination = value;
  }

  get domicile(): ResidenceModel {
    return this._domicile;
  }

  set domicile(value: ResidenceModel) {
    this._domicile = value;
  }

  get gender(): string {
    return this._gender;
  }

  set gender(value: string) {
    this._gender = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get office(): ResidenceModel {
    return this._office;
  }

  set office(value: ResidenceModel) {
    this._office = value;
  }

  get residence(): ResidenceModel {
    return this._residence;
  }

  set residence(value: ResidenceModel) {
    this._residence = value;
  }

  get role(): SubjectRole {
    return this._role;
  }

  set role(value: SubjectRole) {
    this._role = value;
  }

  get surname(): string {
    return this._surname;
  }

  set surname(value: string) {
    this._surname = value;
  }

  get taxCode(): string {
    return this._taxCode;
  }

  set taxCode(value: string) {
    this._taxCode = value;
  }

  get vat(): string {
    return this._vat;
  }

  set vat(value: string) {
    this._vat = value;
  }

  stringify(): string {
    return (this.name || this.surname) ? this.name + ' ' + this.surname : this.denomination;
  }
}
